import { FilterResults, PostFilterBody, screener } from '@api/api/screener';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

import { hasEmptyEntityTagValues } from './utils';

export const fetchFilteredEntitiesTagsOnly = (
  filters: PostFilterBody,
  signal?: AbortSignal
) =>
  wretchRequest<FilterResults>(screener.postFilter.path, {
    method: 'post',
    body: {
      filters,
      tags_only: true,
    },
    signal,
  });

export const fetchFilteredEntities = (
  filters: PostFilterBody,
  signal?: AbortSignal
) => {
  if (hasEmptyEntityTagValues(filters)) {
    return Promise.resolve({
      entities: [],
      data: [],
      page: {
        current: 0,
        size: 0,
        next: undefined,
      },
      total_count: 0,
    });
  }

  return wretchRequest<FilterResults>(screener.postFilter.path, {
    method: 'post',
    body: {
      filters,
      tags_only: false,
    },
    signal,
  });
};
